import { Component, Input } from '@angular/core';
import { PopoverInput } from '../base/popover-input';

import { SupportDataService } from '../../../_services';
import { IRegion } from '../../../_entities';

@Component({
    selector: 'editable-own-region-dropdown',
	template: require('./own-region-dropdown.component.html')
})
export class OwnRegionDropdownComponent extends PopoverInput  {

	private _regions: IRegion[] = null;

	@Input() countryCode: string;

    constructor(supportData: SupportDataService) {
		super();

		supportData.getOwnRegions().then(result => this._regions = result);
	}

	get displayText() {
		
		if (this._regions) {
			const item = this.items.find(r => r.id === this.originalValue);

			if (item)
				return item.name;

			if (this.originalValue && item == null)
				return "!! " + this.dirtyValue;
		}


		return "";
	}

	get items(): IRegion[] {

		if (this._regions) {
			return this._regions.filter(r => r.countryCode === this.countryCode);	
		}

		return null;
    }

	get selectedItem() {
		if (this.items) {
			return this.items.find(r => r.id === this.dirtyValue);	
		}

		return null;
	}

	set selectedItem(val: IRegion) { this.dirtyValue = val.id; }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/own-region-dropdown.component.ts